import { createDataSelectors } from "@app/modules/app.reducers";
import { DataSourceMetadata } from "@ea/shared_types/next/ea.types";

export const globalExcelsDataSelectors = createDataSelectors<DataSourceMetadata>()("globalExcels");
